<template>
    <div class="homeContainerRefuge ">
        <div class="container underLogoPhrase">
            <h2 class="font-weight-bold mb-4 centers " id="top">{{ news.nom }}</h2>
            <div class="mid">
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-12">

                    <div class="" style="margin-bottom: 0px;">
                        <div class="container " style="margin-top: 20px;">
                            <h4 class="titleblue titlecontainershop" style="text-align: left;"><b>{{ news.resume
                                    }}:</b></h4>
                            <p v-html="formattedArticle" class=""></p>

                        </div>
                    </div>

                    <div class="col-lg-6" v-if="news.image">
                        <br><br>
                    </div>
                    <div class="" style="margin-bottom: 0px;background-color: transparent;">
                        <div class="container " style="margin-top: 20px;">
                            <img class="responsive_img" :src="'https://admin.asso-refuge.fr/images/' + news.image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br><br>

    </div>

</template>

<script>
export default {
  data() {
    return {
      news: {}, // mieux qu'un tableau
    };
  },

  mounted() {
    this.loadNews();
  },

  watch: {
    "$route.params.id": {
      immediate: false,
      handler() {
        this.loadNews();
      },
    },
  },

  methods: {
    loadNews() {
      const idSite = this.$idSite;
      const id = this.$route.params.id;

      fetch(`https://admin.asso-refuge.fr/getNewsDetails/${idSite}/${id}`)
        .then((response) => response.json())
        .then((data) => {
          this.news = (data && data[0]) ? data[0] : {};
        })
        .catch((error) => {
          console.error("Il y a eu un problème avec votre requête :", error.message);
          this.news = {};
        });
    },
  },

  computed: {
    formattedArticle() {
      return this.news?.article || "";
    },
  },
};
</script>
